var map = {
	"./Access Bank.png": "e85c",
	"./Citibank.png": "378b",
	"./Diamond Bank.png": "5085",
	"./Ecobank Nigeria.png": "6ef9",
	"./Fidelity Bank Nigeria.png": "d319",
	"./First Bank of Nigeria.png": "3125",
	"./First City Monument Bank.png": "8748",
	"./Guaranty Trust Bank.png": "464a",
	"./Heritage Bank Plc.png": "69ab",
	"./Jaiz Bank.png": "ac51",
	"./Keystone Bank Limited.png": "e430",
	"./Kuda Bank.png": "a72a",
	"./Polaris (Skye Bank).png": "8684",
	"./Providus Bank Plc.png": "9b3e",
	"./Rubies Bank.png": "f3d9",
	"./Stanbic IBTC Bank Nigeria Limited.png": "1f56",
	"./Standard Chartered Bank.png": "bb74",
	"./Sterling Bank.png": "ac6af",
	"./Suntrust Bank Nigeria Limited.png": "a86d",
	"./Union Bank of Nigeria.png": "d31f",
	"./United Bank for Africa.png": "eb3f",
	"./Unity Bank Plc.png": "0db5",
	"./Wema Bank.png": "4f72",
	"./Zenith Bank.png": "c3e3",
	"./google-play.png": "c4cb",
	"./hero-screenshot-2.png": "bc65",
	"./hourglass.png": "da2d",
	"./p2p.png": "b818"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";